var map = {
	"./2019/carbonmonoxide/2019-01-California-carbonmonoxide.txt": 35568,
	"./2019/carbonmonoxide/2019-01-Florida-carbonmonoxide.txt": 52514,
	"./2019/carbonmonoxide/2019-01-Illinois-carbonmonoxide.txt": 26367,
	"./2019/carbonmonoxide/2019-01-New-York-carbonmonoxide.txt": 42136,
	"./2019/carbonmonoxide/2019-01-Texas-carbonmonoxide.txt": 72486,
	"./2019/carbonmonoxide/2019-02-California-carbonmonoxide.txt": 50920,
	"./2019/carbonmonoxide/2019-02-Florida-carbonmonoxide.txt": 65267,
	"./2019/carbonmonoxide/2019-02-Illinois-carbonmonoxide.txt": 11861,
	"./2019/carbonmonoxide/2019-02-New-York-carbonmonoxide.txt": 55705,
	"./2019/carbonmonoxide/2019-02-Texas-carbonmonoxide.txt": 36627,
	"./2019/carbonmonoxide/2019-03-California-carbonmonoxide.txt": 57113,
	"./2019/carbonmonoxide/2019-03-Florida-carbonmonoxide.txt": 52288,
	"./2019/carbonmonoxide/2019-03-Illinois-carbonmonoxide.txt": 33815,
	"./2019/carbonmonoxide/2019-03-New-York-carbonmonoxide.txt": 32639,
	"./2019/carbonmonoxide/2019-03-Texas-carbonmonoxide.txt": 37721,
	"./2019/carbonmonoxide/2019-04-California-carbonmonoxide.txt": 99980,
	"./2019/carbonmonoxide/2019-04-Florida-carbonmonoxide.txt": 11579,
	"./2019/carbonmonoxide/2019-04-Illinois-carbonmonoxide.txt": 93281,
	"./2019/carbonmonoxide/2019-04-New-York-carbonmonoxide.txt": 80947,
	"./2019/carbonmonoxide/2019-04-Texas-carbonmonoxide.txt": 89778,
	"./2019/carbonmonoxide/2019-05-California-carbonmonoxide.txt": 91592,
	"./2019/carbonmonoxide/2019-05-Florida-carbonmonoxide.txt": 16147,
	"./2019/carbonmonoxide/2019-05-Illinois-carbonmonoxide.txt": 51097,
	"./2019/carbonmonoxide/2019-05-New-York-carbonmonoxide.txt": 98194,
	"./2019/carbonmonoxide/2019-05-Texas-carbonmonoxide.txt": 60724,
	"./2019/carbonmonoxide/2019-06-California-carbonmonoxide.txt": 66351,
	"./2019/carbonmonoxide/2019-06-Florida-carbonmonoxide.txt": 87912,
	"./2019/carbonmonoxide/2019-06-Illinois-carbonmonoxide.txt": 69371,
	"./2019/carbonmonoxide/2019-06-New-York-carbonmonoxide.txt": 2419,
	"./2019/carbonmonoxide/2019-06-Texas-carbonmonoxide.txt": 43667,
	"./2019/carbonmonoxide/2019-07-California-carbonmonoxide.txt": 23736,
	"./2019/carbonmonoxide/2019-07-Florida-carbonmonoxide.txt": 92222,
	"./2019/carbonmonoxide/2019-07-Illinois-carbonmonoxide.txt": 2707,
	"./2019/carbonmonoxide/2019-07-New-York-carbonmonoxide.txt": 82616,
	"./2019/carbonmonoxide/2019-07-Texas-carbonmonoxide.txt": 20437,
	"./2019/carbonmonoxide/2019-08-California-carbonmonoxide.txt": 85875,
	"./2019/carbonmonoxide/2019-08-Florida-carbonmonoxide.txt": 92329,
	"./2019/carbonmonoxide/2019-08-Illinois-carbonmonoxide.txt": 56370,
	"./2019/carbonmonoxide/2019-08-New-York-carbonmonoxide.txt": 40593,
	"./2019/carbonmonoxide/2019-08-Texas-carbonmonoxide.txt": 55536,
	"./2019/carbonmonoxide/2019-09-California-carbonmonoxide.txt": 88782,
	"./2019/carbonmonoxide/2019-09-Florida-carbonmonoxide.txt": 4479,
	"./2019/carbonmonoxide/2019-09-Illinois-carbonmonoxide.txt": 57380,
	"./2019/carbonmonoxide/2019-09-New-York-carbonmonoxide.txt": 43220,
	"./2019/carbonmonoxide/2019-09-Texas-carbonmonoxide.txt": 15581,
	"./2019/carbonmonoxide/2019-10-California-carbonmonoxide.txt": 87751,
	"./2019/carbonmonoxide/2019-10-Florida-carbonmonoxide.txt": 15669,
	"./2019/carbonmonoxide/2019-10-Illinois-carbonmonoxide.txt": 62862,
	"./2019/carbonmonoxide/2019-10-New-York-carbonmonoxide.txt": 40277,
	"./2019/carbonmonoxide/2019-10-Texas-carbonmonoxide.txt": 44979,
	"./2019/carbonmonoxide/2019-11-California-carbonmonoxide.txt": 69097,
	"./2019/carbonmonoxide/2019-11-Florida-carbonmonoxide.txt": 16695,
	"./2019/carbonmonoxide/2019-11-Illinois-carbonmonoxide.txt": 22778,
	"./2019/carbonmonoxide/2019-11-New-York-carbonmonoxide.txt": 52209,
	"./2019/carbonmonoxide/2019-11-Texas-carbonmonoxide.txt": 88684,
	"./2019/carbonmonoxide/2019-12-California-carbonmonoxide.txt": 12960,
	"./2019/carbonmonoxide/2019-12-Florida-carbonmonoxide.txt": 72518,
	"./2019/carbonmonoxide/2019-12-Illinois-carbonmonoxide.txt": 38620,
	"./2019/carbonmonoxide/2019-12-New-York-carbonmonoxide.txt": 10576,
	"./2019/carbonmonoxide/2019-12-Texas-carbonmonoxide.txt": 14029,
	"./2019/methane/2019-01-California-methane.txt": 53191,
	"./2019/methane/2019-01-Florida-methane.txt": 84326,
	"./2019/methane/2019-01-Illinois-methane.txt": 90283,
	"./2019/methane/2019-01-New-York-methane.txt": 54855,
	"./2019/methane/2019-01-Texas-methane.txt": 64329,
	"./2019/methane/2019-02-California-methane.txt": 17422,
	"./2019/methane/2019-02-Florida-methane.txt": 20240,
	"./2019/methane/2019-02-Illinois-methane.txt": 54506,
	"./2019/methane/2019-02-New-York-methane.txt": 7953,
	"./2019/methane/2019-02-Texas-methane.txt": 87549,
	"./2019/methane/2019-03-California-methane.txt": 85458,
	"./2019/methane/2019-03-Florida-methane.txt": 17489,
	"./2019/methane/2019-03-Illinois-methane.txt": 54791,
	"./2019/methane/2019-03-New-York-methane.txt": 21466,
	"./2019/methane/2019-03-Texas-methane.txt": 90643,
	"./2019/methane/2019-04-California-methane.txt": 7454,
	"./2019/methane/2019-04-Florida-methane.txt": 4716,
	"./2019/methane/2019-04-Illinois-methane.txt": 79362,
	"./2019/methane/2019-04-New-York-methane.txt": 39501,
	"./2019/methane/2019-04-Texas-methane.txt": 41086,
	"./2019/methane/2019-05-California-methane.txt": 65569,
	"./2019/methane/2019-05-Florida-methane.txt": 97872,
	"./2019/methane/2019-05-Illinois-methane.txt": 52019,
	"./2019/methane/2019-05-New-York-methane.txt": 23429,
	"./2019/methane/2019-05-Texas-methane.txt": 1038,
	"./2019/methane/2019-06-California-methane.txt": 75452,
	"./2019/methane/2019-06-Florida-methane.txt": 17915,
	"./2019/methane/2019-06-Illinois-methane.txt": 62264,
	"./2019/methane/2019-06-New-York-methane.txt": 22914,
	"./2019/methane/2019-06-Texas-methane.txt": 52929,
	"./2019/methane/2019-07-California-methane.txt": 47752,
	"./2019/methane/2019-07-Florida-methane.txt": 59345,
	"./2019/methane/2019-07-Illinois-methane.txt": 5237,
	"./2019/methane/2019-07-New-York-methane.txt": 69449,
	"./2019/methane/2019-07-Texas-methane.txt": 5992,
	"./2019/methane/2019-08-California-methane.txt": 71773,
	"./2019/methane/2019-08-Florida-methane.txt": 92140,
	"./2019/methane/2019-08-Illinois-methane.txt": 64806,
	"./2019/methane/2019-08-New-York-methane.txt": 38330,
	"./2019/methane/2019-08-Texas-methane.txt": 20569,
	"./2019/methane/2019-09-California-methane.txt": 83884,
	"./2019/methane/2019-09-Florida-methane.txt": 33389,
	"./2019/methane/2019-09-Illinois-methane.txt": 68820,
	"./2019/methane/2019-09-New-York-methane.txt": 54326,
	"./2019/methane/2019-09-Texas-methane.txt": 60156,
	"./2019/methane/2019-10-California-methane.txt": 81121,
	"./2019/methane/2019-10-Florida-methane.txt": 26563,
	"./2019/methane/2019-10-Illinois-methane.txt": 39411,
	"./2019/methane/2019-10-New-York-methane.txt": 13656,
	"./2019/methane/2019-10-Texas-methane.txt": 52584,
	"./2019/methane/2019-11-California-methane.txt": 37272,
	"./2019/methane/2019-11-Florida-methane.txt": 73582,
	"./2019/methane/2019-11-Illinois-methane.txt": 88392,
	"./2019/methane/2019-11-New-York-methane.txt": 8749,
	"./2019/methane/2019-11-Texas-methane.txt": 62989,
	"./2019/methane/2019-12-California-methane.txt": 31163,
	"./2019/methane/2019-12-Florida-methane.txt": 3477,
	"./2019/methane/2019-12-Illinois-methane.txt": 55259,
	"./2019/methane/2019-12-New-York-methane.txt": 80987,
	"./2019/methane/2019-12-Texas-methane.txt": 46154,
	"./2019/nitrogendioxide/2019-01-California-nitrogendioxide.txt": 78290,
	"./2019/nitrogendioxide/2019-01-Florida-nitrogendioxide.txt": 72599,
	"./2019/nitrogendioxide/2019-01-Illinois-nitrogendioxide.txt": 55538,
	"./2019/nitrogendioxide/2019-01-New-York-nitrogendioxide.txt": 23376,
	"./2019/nitrogendioxide/2019-01-Texas-nitrogendioxide.txt": 96164,
	"./2019/nitrogendioxide/2019-02-California-nitrogendioxide.txt": 49223,
	"./2019/nitrogendioxide/2019-02-Florida-nitrogendioxide.txt": 59363,
	"./2019/nitrogendioxide/2019-02-Illinois-nitrogendioxide.txt": 48216,
	"./2019/nitrogendioxide/2019-02-New-York-nitrogendioxide.txt": 19586,
	"./2019/nitrogendioxide/2019-02-Texas-nitrogendioxide.txt": 97529,
	"./2019/nitrogendioxide/2019-03-California-nitrogendioxide.txt": 47330,
	"./2019/nitrogendioxide/2019-03-Florida-nitrogendioxide.txt": 92588,
	"./2019/nitrogendioxide/2019-03-Illinois-nitrogendioxide.txt": 48543,
	"./2019/nitrogendioxide/2019-03-New-York-nitrogendioxide.txt": 78075,
	"./2019/nitrogendioxide/2019-03-Texas-nitrogendioxide.txt": 73943,
	"./2019/nitrogendioxide/2019-04-California-nitrogendioxide.txt": 21376,
	"./2019/nitrogendioxide/2019-04-Florida-nitrogendioxide.txt": 97189,
	"./2019/nitrogendioxide/2019-04-Illinois-nitrogendioxide.txt": 38489,
	"./2019/nitrogendioxide/2019-04-New-York-nitrogendioxide.txt": 19692,
	"./2019/nitrogendioxide/2019-04-Texas-nitrogendioxide.txt": 36719,
	"./2019/nitrogendioxide/2019-05-California-nitrogendioxide.txt": 2539,
	"./2019/nitrogendioxide/2019-05-Florida-nitrogendioxide.txt": 11478,
	"./2019/nitrogendioxide/2019-05-Illinois-nitrogendioxide.txt": 20444,
	"./2019/nitrogendioxide/2019-05-New-York-nitrogendioxide.txt": 8338,
	"./2019/nitrogendioxide/2019-05-Texas-nitrogendioxide.txt": 46794,
	"./2019/nitrogendioxide/2019-06-California-nitrogendioxide.txt": 29229,
	"./2019/nitrogendioxide/2019-06-Florida-nitrogendioxide.txt": 90428,
	"./2019/nitrogendioxide/2019-06-Illinois-nitrogendioxide.txt": 14426,
	"./2019/nitrogendioxide/2019-06-New-York-nitrogendioxide.txt": 14280,
	"./2019/nitrogendioxide/2019-06-Texas-nitrogendioxide.txt": 48763,
	"./2019/nitrogendioxide/2019-07-California-nitrogendioxide.txt": 63734,
	"./2019/nitrogendioxide/2019-07-Florida-nitrogendioxide.txt": 10301,
	"./2019/nitrogendioxide/2019-07-Illinois-nitrogendioxide.txt": 72068,
	"./2019/nitrogendioxide/2019-07-New-York-nitrogendioxide.txt": 15760,
	"./2019/nitrogendioxide/2019-07-Texas-nitrogendioxide.txt": 75645,
	"./2019/nitrogendioxide/2019-08-California-nitrogendioxide.txt": 56135,
	"./2019/nitrogendioxide/2019-08-Florida-nitrogendioxide.txt": 43591,
	"./2019/nitrogendioxide/2019-08-Illinois-nitrogendioxide.txt": 5066,
	"./2019/nitrogendioxide/2019-08-New-York-nitrogendioxide.txt": 11939,
	"./2019/nitrogendioxide/2019-08-Texas-nitrogendioxide.txt": 86919,
	"./2019/nitrogendioxide/2019-09-California-nitrogendioxide.txt": 99776,
	"./2019/nitrogendioxide/2019-09-Florida-nitrogendioxide.txt": 81210,
	"./2019/nitrogendioxide/2019-09-Illinois-nitrogendioxide.txt": 77594,
	"./2019/nitrogendioxide/2019-09-New-York-nitrogendioxide.txt": 97892,
	"./2019/nitrogendioxide/2019-09-Texas-nitrogendioxide.txt": 59255,
	"./2019/nitrogendioxide/2019-10-California-nitrogendioxide.txt": 31571,
	"./2019/nitrogendioxide/2019-10-Florida-nitrogendioxide.txt": 78081,
	"./2019/nitrogendioxide/2019-10-Illinois-nitrogendioxide.txt": 29120,
	"./2019/nitrogendioxide/2019-10-New-York-nitrogendioxide.txt": 31854,
	"./2019/nitrogendioxide/2019-10-Texas-nitrogendioxide.txt": 3949,
	"./2019/nitrogendioxide/2019-11-California-nitrogendioxide.txt": 45569,
	"./2019/nitrogendioxide/2019-11-Florida-nitrogendioxide.txt": 82611,
	"./2019/nitrogendioxide/2019-11-Illinois-nitrogendioxide.txt": 53236,
	"./2019/nitrogendioxide/2019-11-New-York-nitrogendioxide.txt": 46262,
	"./2019/nitrogendioxide/2019-11-Texas-nitrogendioxide.txt": 36491,
	"./2019/nitrogendioxide/2019-12-California-nitrogendioxide.txt": 91858,
	"./2019/nitrogendioxide/2019-12-Florida-nitrogendioxide.txt": 88778,
	"./2019/nitrogendioxide/2019-12-Illinois-nitrogendioxide.txt": 84572,
	"./2019/nitrogendioxide/2019-12-New-York-nitrogendioxide.txt": 68628,
	"./2019/nitrogendioxide/2019-12-Texas-nitrogendioxide.txt": 67822,
	"./2019/ozone/2019-01-California-ozone.txt": 46066,
	"./2019/ozone/2019-01-Florida-ozone.txt": 65425,
	"./2019/ozone/2019-01-Illinois-ozone.txt": 67213,
	"./2019/ozone/2019-01-New-York-ozone.txt": 72151,
	"./2019/ozone/2019-01-Texas-ozone.txt": 255,
	"./2019/ozone/2019-02-California-ozone.txt": 80922,
	"./2019/ozone/2019-02-Florida-ozone.txt": 74025,
	"./2019/ozone/2019-02-Illinois-ozone.txt": 21848,
	"./2019/ozone/2019-02-New-York-ozone.txt": 18103,
	"./2019/ozone/2019-02-Texas-ozone.txt": 30701,
	"./2019/ozone/2019-03-California-ozone.txt": 12415,
	"./2019/ozone/2019-03-Florida-ozone.txt": 42758,
	"./2019/ozone/2019-03-Illinois-ozone.txt": 14418,
	"./2019/ozone/2019-03-New-York-ozone.txt": 88380,
	"./2019/ozone/2019-03-Texas-ozone.txt": 45155,
	"./2019/ozone/2019-04-California-ozone.txt": 35335,
	"./2019/ozone/2019-04-Florida-ozone.txt": 12600,
	"./2019/ozone/2019-04-Illinois-ozone.txt": 19046,
	"./2019/ozone/2019-04-New-York-ozone.txt": 54693,
	"./2019/ozone/2019-04-Texas-ozone.txt": 99416,
	"./2019/ozone/2019-05-California-ozone.txt": 97378,
	"./2019/ozone/2019-05-Florida-ozone.txt": 98274,
	"./2019/ozone/2019-05-Illinois-ozone.txt": 69150,
	"./2019/ozone/2019-05-New-York-ozone.txt": 19644,
	"./2019/ozone/2019-05-Texas-ozone.txt": 19415,
	"./2019/ozone/2019-06-California-ozone.txt": 64938,
	"./2019/ozone/2019-06-Florida-ozone.txt": 74037,
	"./2019/ozone/2019-06-Illinois-ozone.txt": 89887,
	"./2019/ozone/2019-06-New-York-ozone.txt": 20256,
	"./2019/ozone/2019-06-Texas-ozone.txt": 69161,
	"./2019/ozone/2019-07-California-ozone.txt": 9202,
	"./2019/ozone/2019-07-Florida-ozone.txt": 94941,
	"./2019/ozone/2019-07-Illinois-ozone.txt": 82816,
	"./2019/ozone/2019-07-New-York-ozone.txt": 55781,
	"./2019/ozone/2019-07-Texas-ozone.txt": 76383,
	"./2019/ozone/2019-08-California-ozone.txt": 88063,
	"./2019/ozone/2019-08-Florida-ozone.txt": 42856,
	"./2019/ozone/2019-08-Illinois-ozone.txt": 88142,
	"./2019/ozone/2019-08-New-York-ozone.txt": 39853,
	"./2019/ozone/2019-08-Texas-ozone.txt": 75157,
	"./2019/ozone/2019-09-California-ozone.txt": 2530,
	"./2019/ozone/2019-09-Florida-ozone.txt": 68478,
	"./2019/ozone/2019-09-Illinois-ozone.txt": 11862,
	"./2019/ozone/2019-09-New-York-ozone.txt": 88681,
	"./2019/ozone/2019-09-Texas-ozone.txt": 92309,
	"./2019/ozone/2019-10-California-ozone.txt": 58706,
	"./2019/ozone/2019-10-Florida-ozone.txt": 81726,
	"./2019/ozone/2019-10-Illinois-ozone.txt": 73255,
	"./2019/ozone/2019-10-New-York-ozone.txt": 43868,
	"./2019/ozone/2019-10-Texas-ozone.txt": 49517,
	"./2019/ozone/2019-11-California-ozone.txt": 11361,
	"./2019/ozone/2019-11-Florida-ozone.txt": 10134,
	"./2019/ozone/2019-11-Illinois-ozone.txt": 24701,
	"./2019/ozone/2019-11-New-York-ozone.txt": 14477,
	"./2019/ozone/2019-11-Texas-ozone.txt": 62724,
	"./2019/ozone/2019-12-California-ozone.txt": 60770,
	"./2019/ozone/2019-12-Florida-ozone.txt": 60102,
	"./2019/ozone/2019-12-Illinois-ozone.txt": 79457,
	"./2019/ozone/2019-12-New-York-ozone.txt": 59926,
	"./2019/ozone/2019-12-Texas-ozone.txt": 81049,
	"./2020/carbonmonoxide/2020-01-California-carbonmonoxide.txt": 70659,
	"./2020/carbonmonoxide/2020-01-Florida-carbonmonoxide.txt": 12427,
	"./2020/carbonmonoxide/2020-01-Illinois-carbonmonoxide.txt": 38076,
	"./2020/carbonmonoxide/2020-01-New-York-carbonmonoxide.txt": 61655,
	"./2020/carbonmonoxide/2020-01-Texas-carbonmonoxide.txt": 23911,
	"./2020/carbonmonoxide/2020-02-California-carbonmonoxide.txt": 4072,
	"./2020/carbonmonoxide/2020-02-Florida-carbonmonoxide.txt": 43535,
	"./2020/carbonmonoxide/2020-02-Illinois-carbonmonoxide.txt": 59541,
	"./2020/carbonmonoxide/2020-02-New-York-carbonmonoxide.txt": 19579,
	"./2020/carbonmonoxide/2020-02-Texas-carbonmonoxide.txt": 6144,
	"./2020/carbonmonoxide/2020-03-California-carbonmonoxide.txt": 3100,
	"./2020/carbonmonoxide/2020-03-Florida-carbonmonoxide.txt": 3134,
	"./2020/carbonmonoxide/2020-03-Illinois-carbonmonoxide.txt": 76224,
	"./2020/carbonmonoxide/2020-03-New-York-carbonmonoxide.txt": 91048,
	"./2020/carbonmonoxide/2020-03-Texas-carbonmonoxide.txt": 58010,
	"./2020/carbonmonoxide/2020-04-California-carbonmonoxide.txt": 59434,
	"./2020/carbonmonoxide/2020-04-Florida-carbonmonoxide.txt": 53821,
	"./2020/carbonmonoxide/2020-04-Illinois-carbonmonoxide.txt": 90751,
	"./2020/carbonmonoxide/2020-04-New-York-carbonmonoxide.txt": 97320,
	"./2020/carbonmonoxide/2020-04-Texas-carbonmonoxide.txt": 66325,
	"./2020/carbonmonoxide/2020-05-California-carbonmonoxide.txt": 42693,
	"./2020/carbonmonoxide/2020-05-Florida-carbonmonoxide.txt": 70144,
	"./2020/carbonmonoxide/2020-05-Illinois-carbonmonoxide.txt": 52074,
	"./2020/carbonmonoxide/2020-05-New-York-carbonmonoxide.txt": 48499,
	"./2020/carbonmonoxide/2020-05-Texas-carbonmonoxide.txt": 50837,
	"./2020/carbonmonoxide/2020-06-California-carbonmonoxide.txt": 37766,
	"./2020/carbonmonoxide/2020-06-Florida-carbonmonoxide.txt": 34720,
	"./2020/carbonmonoxide/2020-06-Illinois-carbonmonoxide.txt": 12984,
	"./2020/carbonmonoxide/2020-06-New-York-carbonmonoxide.txt": 71946,
	"./2020/carbonmonoxide/2020-06-Texas-carbonmonoxide.txt": 33844,
	"./2020/carbonmonoxide/2020-07-California-carbonmonoxide.txt": 49217,
	"./2020/carbonmonoxide/2020-07-Florida-carbonmonoxide.txt": 40792,
	"./2020/carbonmonoxide/2020-07-Illinois-carbonmonoxide.txt": 68558,
	"./2020/carbonmonoxide/2020-07-New-York-carbonmonoxide.txt": 62943,
	"./2020/carbonmonoxide/2020-07-Texas-carbonmonoxide.txt": 66498,
	"./2020/carbonmonoxide/2020-08-California-carbonmonoxide.txt": 64742,
	"./2020/carbonmonoxide/2020-08-Florida-carbonmonoxide.txt": 50591,
	"./2020/carbonmonoxide/2020-08-Illinois-carbonmonoxide.txt": 40898,
	"./2020/carbonmonoxide/2020-08-New-York-carbonmonoxide.txt": 18706,
	"./2020/carbonmonoxide/2020-08-Texas-carbonmonoxide.txt": 45046,
	"./2020/carbonmonoxide/2020-09-California-carbonmonoxide.txt": 64857,
	"./2020/carbonmonoxide/2020-09-Florida-carbonmonoxide.txt": 1765,
	"./2020/carbonmonoxide/2020-09-Illinois-carbonmonoxide.txt": 63893,
	"./2020/carbonmonoxide/2020-09-New-York-carbonmonoxide.txt": 34076,
	"./2020/carbonmonoxide/2020-09-Texas-carbonmonoxide.txt": 32270,
	"./2020/carbonmonoxide/2020-10-California-carbonmonoxide.txt": 26059,
	"./2020/carbonmonoxide/2020-10-Florida-carbonmonoxide.txt": 37043,
	"./2020/carbonmonoxide/2020-10-Illinois-carbonmonoxide.txt": 11202,
	"./2020/carbonmonoxide/2020-10-New-York-carbonmonoxide.txt": 72903,
	"./2020/carbonmonoxide/2020-10-Texas-carbonmonoxide.txt": 77967,
	"./2020/carbonmonoxide/2020-11-California-carbonmonoxide.txt": 39457,
	"./2020/carbonmonoxide/2020-11-Florida-carbonmonoxide.txt": 78201,
	"./2020/carbonmonoxide/2020-11-Illinois-carbonmonoxide.txt": 98855,
	"./2020/carbonmonoxide/2020-11-New-York-carbonmonoxide.txt": 99320,
	"./2020/carbonmonoxide/2020-11-Texas-carbonmonoxide.txt": 91491,
	"./2020/carbonmonoxide/2020-12-California-carbonmonoxide.txt": 27617,
	"./2020/carbonmonoxide/2020-12-Florida-carbonmonoxide.txt": 42963,
	"./2020/carbonmonoxide/2020-12-Illinois-carbonmonoxide.txt": 3800,
	"./2020/carbonmonoxide/2020-12-New-York-carbonmonoxide.txt": 12545,
	"./2020/carbonmonoxide/2020-12-Texas-carbonmonoxide.txt": 72277,
	"./2020/methane/2020-01-California-methane.txt": 645,
	"./2020/methane/2020-01-Florida-methane.txt": 74434,
	"./2020/methane/2020-01-Illinois-methane.txt": 25981,
	"./2020/methane/2020-01-New-York-methane.txt": 81086,
	"./2020/methane/2020-01-Texas-methane.txt": 52265,
	"./2020/methane/2020-02-California-methane.txt": 35563,
	"./2020/methane/2020-02-Florida-methane.txt": 72371,
	"./2020/methane/2020-02-Illinois-methane.txt": 49593,
	"./2020/methane/2020-02-New-York-methane.txt": 38181,
	"./2020/methane/2020-02-Texas-methane.txt": 59530,
	"./2020/methane/2020-03-California-methane.txt": 12385,
	"./2020/methane/2020-03-Florida-methane.txt": 45758,
	"./2020/methane/2020-03-Illinois-methane.txt": 23938,
	"./2020/methane/2020-03-New-York-methane.txt": 38199,
	"./2020/methane/2020-03-Texas-methane.txt": 76909,
	"./2020/methane/2020-04-California-methane.txt": 26046,
	"./2020/methane/2020-04-Florida-methane.txt": 6624,
	"./2020/methane/2020-04-Illinois-methane.txt": 79903,
	"./2020/methane/2020-04-New-York-methane.txt": 94542,
	"./2020/methane/2020-04-Texas-methane.txt": 32349,
	"./2020/methane/2020-05-California-methane.txt": 88081,
	"./2020/methane/2020-05-Florida-methane.txt": 75208,
	"./2020/methane/2020-05-Illinois-methane.txt": 57474,
	"./2020/methane/2020-05-New-York-methane.txt": 11867,
	"./2020/methane/2020-05-Texas-methane.txt": 28655,
	"./2020/methane/2020-06-California-methane.txt": 5336,
	"./2020/methane/2020-06-Florida-methane.txt": 36349,
	"./2020/methane/2020-06-Illinois-methane.txt": 69081,
	"./2020/methane/2020-06-New-York-methane.txt": 77098,
	"./2020/methane/2020-06-Texas-methane.txt": 95917,
	"./2020/methane/2020-07-California-methane.txt": 16489,
	"./2020/methane/2020-07-Florida-methane.txt": 75667,
	"./2020/methane/2020-07-Illinois-methane.txt": 66174,
	"./2020/methane/2020-07-New-York-methane.txt": 81075,
	"./2020/methane/2020-07-Texas-methane.txt": 32378,
	"./2020/methane/2020-08-California-methane.txt": 75977,
	"./2020/methane/2020-08-Florida-methane.txt": 66147,
	"./2020/methane/2020-08-Illinois-methane.txt": 34441,
	"./2020/methane/2020-08-New-York-methane.txt": 75591,
	"./2020/methane/2020-08-Texas-methane.txt": 68260,
	"./2020/methane/2020-09-California-methane.txt": 63815,
	"./2020/methane/2020-09-Florida-methane.txt": 98396,
	"./2020/methane/2020-09-Illinois-methane.txt": 98637,
	"./2020/methane/2020-09-New-York-methane.txt": 11528,
	"./2020/methane/2020-09-Texas-methane.txt": 74373,
	"./2020/methane/2020-10-California-methane.txt": 47229,
	"./2020/methane/2020-10-Florida-methane.txt": 74568,
	"./2020/methane/2020-10-Illinois-methane.txt": 73557,
	"./2020/methane/2020-10-New-York-methane.txt": 86608,
	"./2020/methane/2020-10-Texas-methane.txt": 15287,
	"./2020/methane/2020-11-California-methane.txt": 87385,
	"./2020/methane/2020-11-Florida-methane.txt": 98493,
	"./2020/methane/2020-11-Illinois-methane.txt": 91481,
	"./2020/methane/2020-11-New-York-methane.txt": 99791,
	"./2020/methane/2020-11-Texas-methane.txt": 22487,
	"./2020/methane/2020-12-California-methane.txt": 21325,
	"./2020/methane/2020-12-Florida-methane.txt": 93424,
	"./2020/methane/2020-12-Illinois-methane.txt": 10614,
	"./2020/methane/2020-12-New-York-methane.txt": 19121,
	"./2020/methane/2020-12-Texas-methane.txt": 34898,
	"./2020/nitrogendioxide/2020-01-California-nitrogendioxide.txt": 7924,
	"./2020/nitrogendioxide/2020-01-Florida-nitrogendioxide.txt": 47209,
	"./2020/nitrogendioxide/2020-01-Illinois-nitrogendioxide.txt": 86698,
	"./2020/nitrogendioxide/2020-01-New-York-nitrogendioxide.txt": 51430,
	"./2020/nitrogendioxide/2020-01-Texas-nitrogendioxide.txt": 58639,
	"./2020/nitrogendioxide/2020-02-California-nitrogendioxide.txt": 29574,
	"./2020/nitrogendioxide/2020-02-Florida-nitrogendioxide.txt": 64371,
	"./2020/nitrogendioxide/2020-02-Illinois-nitrogendioxide.txt": 5957,
	"./2020/nitrogendioxide/2020-02-New-York-nitrogendioxide.txt": 44730,
	"./2020/nitrogendioxide/2020-02-Texas-nitrogendioxide.txt": 53413,
	"./2020/nitrogendioxide/2020-03-California-nitrogendioxide.txt": 74472,
	"./2020/nitrogendioxide/2020-03-Florida-nitrogendioxide.txt": 92893,
	"./2020/nitrogendioxide/2020-03-Illinois-nitrogendioxide.txt": 51666,
	"./2020/nitrogendioxide/2020-03-New-York-nitrogendioxide.txt": 16392,
	"./2020/nitrogendioxide/2020-03-Texas-nitrogendioxide.txt": 11425,
	"./2020/nitrogendioxide/2020-04-California-nitrogendioxide.txt": 9833,
	"./2020/nitrogendioxide/2020-04-Florida-nitrogendioxide.txt": 62978,
	"./2020/nitrogendioxide/2020-04-Illinois-nitrogendioxide.txt": 18321,
	"./2020/nitrogendioxide/2020-04-New-York-nitrogendioxide.txt": 27045,
	"./2020/nitrogendioxide/2020-04-Texas-nitrogendioxide.txt": 7211,
	"./2020/nitrogendioxide/2020-05-California-nitrogendioxide.txt": 62722,
	"./2020/nitrogendioxide/2020-05-Florida-nitrogendioxide.txt": 82619,
	"./2020/nitrogendioxide/2020-05-Illinois-nitrogendioxide.txt": 60200,
	"./2020/nitrogendioxide/2020-05-New-York-nitrogendioxide.txt": 20512,
	"./2020/nitrogendioxide/2020-05-Texas-nitrogendioxide.txt": 55423,
	"./2020/nitrogendioxide/2020-06-California-nitrogendioxide.txt": 54674,
	"./2020/nitrogendioxide/2020-06-Florida-nitrogendioxide.txt": 77014,
	"./2020/nitrogendioxide/2020-06-Illinois-nitrogendioxide.txt": 58406,
	"./2020/nitrogendioxide/2020-06-New-York-nitrogendioxide.txt": 47937,
	"./2020/nitrogendioxide/2020-06-Texas-nitrogendioxide.txt": 70317,
	"./2020/nitrogendioxide/2020-07-California-nitrogendioxide.txt": 37258,
	"./2020/nitrogendioxide/2020-07-Florida-nitrogendioxide.txt": 62121,
	"./2020/nitrogendioxide/2020-07-Illinois-nitrogendioxide.txt": 22326,
	"./2020/nitrogendioxide/2020-07-New-York-nitrogendioxide.txt": 27929,
	"./2020/nitrogendioxide/2020-07-Texas-nitrogendioxide.txt": 11190,
	"./2020/nitrogendioxide/2020-08-California-nitrogendioxide.txt": 13063,
	"./2020/nitrogendioxide/2020-08-Florida-nitrogendioxide.txt": 88157,
	"./2020/nitrogendioxide/2020-08-Illinois-nitrogendioxide.txt": 35963,
	"./2020/nitrogendioxide/2020-08-New-York-nitrogendioxide.txt": 26980,
	"./2020/nitrogendioxide/2020-08-Texas-nitrogendioxide.txt": 13610,
	"./2020/nitrogendioxide/2020-09-California-nitrogendioxide.txt": 71881,
	"./2020/nitrogendioxide/2020-09-Florida-nitrogendioxide.txt": 36641,
	"./2020/nitrogendioxide/2020-09-Illinois-nitrogendioxide.txt": 69722,
	"./2020/nitrogendioxide/2020-09-New-York-nitrogendioxide.txt": 91698,
	"./2020/nitrogendioxide/2020-09-Texas-nitrogendioxide.txt": 75826,
	"./2020/nitrogendioxide/2020-10-California-nitrogendioxide.txt": 15058,
	"./2020/nitrogendioxide/2020-10-Florida-nitrogendioxide.txt": 79641,
	"./2020/nitrogendioxide/2020-10-Illinois-nitrogendioxide.txt": 44058,
	"./2020/nitrogendioxide/2020-10-New-York-nitrogendioxide.txt": 89885,
	"./2020/nitrogendioxide/2020-10-Texas-nitrogendioxide.txt": 31071,
	"./2020/nitrogendioxide/2020-11-California-nitrogendioxide.txt": 95714,
	"./2020/nitrogendioxide/2020-11-Florida-nitrogendioxide.txt": 42546,
	"./2020/nitrogendioxide/2020-11-Illinois-nitrogendioxide.txt": 78891,
	"./2020/nitrogendioxide/2020-11-New-York-nitrogendioxide.txt": 91552,
	"./2020/nitrogendioxide/2020-11-Texas-nitrogendioxide.txt": 54228,
	"./2020/nitrogendioxide/2020-12-California-nitrogendioxide.txt": 70074,
	"./2020/nitrogendioxide/2020-12-Florida-nitrogendioxide.txt": 70358,
	"./2020/nitrogendioxide/2020-12-Illinois-nitrogendioxide.txt": 29930,
	"./2020/nitrogendioxide/2020-12-New-York-nitrogendioxide.txt": 6347,
	"./2020/nitrogendioxide/2020-12-Texas-nitrogendioxide.txt": 42509,
	"./2020/ozone/2020-01-California-ozone.txt": 61805,
	"./2020/ozone/2020-01-Florida-ozone.txt": 77194,
	"./2020/ozone/2020-01-Illinois-ozone.txt": 98675,
	"./2020/ozone/2020-01-New-York-ozone.txt": 70519,
	"./2020/ozone/2020-01-Texas-ozone.txt": 33654,
	"./2020/ozone/2020-02-California-ozone.txt": 31382,
	"./2020/ozone/2020-02-Florida-ozone.txt": 54205,
	"./2020/ozone/2020-02-Illinois-ozone.txt": 4889,
	"./2020/ozone/2020-02-New-York-ozone.txt": 52979,
	"./2020/ozone/2020-02-Texas-ozone.txt": 63316,
	"./2020/ozone/2020-03-California-ozone.txt": 9357,
	"./2020/ozone/2020-03-Florida-ozone.txt": 20877,
	"./2020/ozone/2020-03-Illinois-ozone.txt": 94982,
	"./2020/ozone/2020-03-New-York-ozone.txt": 89663,
	"./2020/ozone/2020-03-Texas-ozone.txt": 93645,
	"./2020/ozone/2020-04-California-ozone.txt": 46994,
	"./2020/ozone/2020-04-Florida-ozone.txt": 40103,
	"./2020/ozone/2020-04-Illinois-ozone.txt": 81896,
	"./2020/ozone/2020-04-New-York-ozone.txt": 74679,
	"./2020/ozone/2020-04-Texas-ozone.txt": 86331,
	"./2020/ozone/2020-05-California-ozone.txt": 12464,
	"./2020/ozone/2020-05-Florida-ozone.txt": 86606,
	"./2020/ozone/2020-05-Illinois-ozone.txt": 86069,
	"./2020/ozone/2020-05-New-York-ozone.txt": 38283,
	"./2020/ozone/2020-05-Texas-ozone.txt": 80463,
	"./2020/ozone/2020-06-California-ozone.txt": 23320,
	"./2020/ozone/2020-06-Florida-ozone.txt": 97747,
	"./2020/ozone/2020-06-Illinois-ozone.txt": 74708,
	"./2020/ozone/2020-06-New-York-ozone.txt": 37997,
	"./2020/ozone/2020-06-Texas-ozone.txt": 40932,
	"./2020/ozone/2020-07-California-ozone.txt": 77326,
	"./2020/ozone/2020-07-Florida-ozone.txt": 48916,
	"./2020/ozone/2020-07-Illinois-ozone.txt": 82150,
	"./2020/ozone/2020-07-New-York-ozone.txt": 27483,
	"./2020/ozone/2020-07-Texas-ozone.txt": 33650,
	"./2020/ozone/2020-08-California-ozone.txt": 14519,
	"./2020/ozone/2020-08-Florida-ozone.txt": 89346,
	"./2020/ozone/2020-08-Illinois-ozone.txt": 43640,
	"./2020/ozone/2020-08-New-York-ozone.txt": 8358,
	"./2020/ozone/2020-08-Texas-ozone.txt": 20661,
	"./2020/ozone/2020-09-California-ozone.txt": 29818,
	"./2020/ozone/2020-09-Florida-ozone.txt": 98491,
	"./2020/ozone/2020-09-Illinois-ozone.txt": 35676,
	"./2020/ozone/2020-09-New-York-ozone.txt": 57942,
	"./2020/ozone/2020-09-Texas-ozone.txt": 38061,
	"./2020/ozone/2020-10-California-ozone.txt": 32271,
	"./2020/ozone/2020-10-Florida-ozone.txt": 17069,
	"./2020/ozone/2020-10-Illinois-ozone.txt": 46172,
	"./2020/ozone/2020-10-New-York-ozone.txt": 70021,
	"./2020/ozone/2020-10-Texas-ozone.txt": 53453,
	"./2020/ozone/2020-11-California-ozone.txt": 71690,
	"./2020/ozone/2020-11-Florida-ozone.txt": 31606,
	"./2020/ozone/2020-11-Illinois-ozone.txt": 70451,
	"./2020/ozone/2020-11-New-York-ozone.txt": 28401,
	"./2020/ozone/2020-11-Texas-ozone.txt": 3573,
	"./2020/ozone/2020-12-California-ozone.txt": 16765,
	"./2020/ozone/2020-12-Florida-ozone.txt": 67804,
	"./2020/ozone/2020-12-Illinois-ozone.txt": 10606,
	"./2020/ozone/2020-12-New-York-ozone.txt": 48721,
	"./2020/ozone/2020-12-Texas-ozone.txt": 9529,
	"./2021/carbonmonoxide/2021-01-California-carbonmonoxide.txt": 21904,
	"./2021/carbonmonoxide/2021-01-Florida-carbonmonoxide.txt": 28393,
	"./2021/carbonmonoxide/2021-01-Illinois-carbonmonoxide.txt": 80746,
	"./2021/carbonmonoxide/2021-01-New-York-carbonmonoxide.txt": 52574,
	"./2021/carbonmonoxide/2021-01-Texas-carbonmonoxide.txt": 71731,
	"./2021/carbonmonoxide/2021-02-California-carbonmonoxide.txt": 23681,
	"./2021/carbonmonoxide/2021-02-Florida-carbonmonoxide.txt": 48438,
	"./2021/carbonmonoxide/2021-02-Illinois-carbonmonoxide.txt": 10491,
	"./2021/carbonmonoxide/2021-02-New-York-carbonmonoxide.txt": 84931,
	"./2021/carbonmonoxide/2021-02-Texas-carbonmonoxide.txt": 77393,
	"./2021/carbonmonoxide/2021-03-California-carbonmonoxide.txt": 62743,
	"./2021/carbonmonoxide/2021-03-Florida-carbonmonoxide.txt": 23942,
	"./2021/carbonmonoxide/2021-03-Illinois-carbonmonoxide.txt": 82234,
	"./2021/carbonmonoxide/2021-03-New-York-carbonmonoxide.txt": 39332,
	"./2021/carbonmonoxide/2021-03-Texas-carbonmonoxide.txt": 62868,
	"./2021/carbonmonoxide/2021-04-California-carbonmonoxide.txt": 95957,
	"./2021/carbonmonoxide/2021-04-Florida-carbonmonoxide.txt": 50319,
	"./2021/carbonmonoxide/2021-04-Illinois-carbonmonoxide.txt": 51188,
	"./2021/carbonmonoxide/2021-04-New-York-carbonmonoxide.txt": 63928,
	"./2021/carbonmonoxide/2021-04-Texas-carbonmonoxide.txt": 47652,
	"./2021/carbonmonoxide/2021-05-California-carbonmonoxide.txt": 13557,
	"./2021/carbonmonoxide/2021-05-Florida-carbonmonoxide.txt": 895,
	"./2021/carbonmonoxide/2021-05-Illinois-carbonmonoxide.txt": 15723,
	"./2021/carbonmonoxide/2021-05-New-York-carbonmonoxide.txt": 68943,
	"./2021/carbonmonoxide/2021-05-Texas-carbonmonoxide.txt": 67777,
	"./2021/carbonmonoxide/2021-06-California-carbonmonoxide.txt": 84649,
	"./2021/carbonmonoxide/2021-06-Florida-carbonmonoxide.txt": 6418,
	"./2021/carbonmonoxide/2021-06-Illinois-carbonmonoxide.txt": 21514,
	"./2021/carbonmonoxide/2021-06-New-York-carbonmonoxide.txt": 17604,
	"./2021/carbonmonoxide/2021-06-Texas-carbonmonoxide.txt": 89242,
	"./2021/carbonmonoxide/2021-07-California-carbonmonoxide.txt": 69091,
	"./2021/carbonmonoxide/2021-07-Florida-carbonmonoxide.txt": 7210,
	"./2021/carbonmonoxide/2021-07-Illinois-carbonmonoxide.txt": 92296,
	"./2021/carbonmonoxide/2021-07-New-York-carbonmonoxide.txt": 37999,
	"./2021/carbonmonoxide/2021-07-Texas-carbonmonoxide.txt": 12440,
	"./2021/carbonmonoxide/2021-08-California-carbonmonoxide.txt": 4457,
	"./2021/carbonmonoxide/2021-08-Florida-carbonmonoxide.txt": 28466,
	"./2021/carbonmonoxide/2021-08-Illinois-carbonmonoxide.txt": 8842,
	"./2021/carbonmonoxide/2021-08-New-York-carbonmonoxide.txt": 55670,
	"./2021/carbonmonoxide/2021-08-Texas-carbonmonoxide.txt": 15224,
	"./2021/carbonmonoxide/2021-09-California-carbonmonoxide.txt": 91436,
	"./2021/carbonmonoxide/2021-09-Florida-carbonmonoxide.txt": 76997,
	"./2021/carbonmonoxide/2021-09-Illinois-carbonmonoxide.txt": 86904,
	"./2021/carbonmonoxide/2021-09-New-York-carbonmonoxide.txt": 88542,
	"./2021/carbonmonoxide/2021-09-Texas-carbonmonoxide.txt": 56280,
	"./2021/carbonmonoxide/2021-10-California-carbonmonoxide.txt": 52972,
	"./2021/carbonmonoxide/2021-10-Florida-carbonmonoxide.txt": 98700,
	"./2021/carbonmonoxide/2021-10-Illinois-carbonmonoxide.txt": 24222,
	"./2021/carbonmonoxide/2021-10-New-York-carbonmonoxide.txt": 42442,
	"./2021/carbonmonoxide/2021-10-Texas-carbonmonoxide.txt": 13050,
	"./2021/carbonmonoxide/2021-11-California-carbonmonoxide.txt": 30719,
	"./2021/carbonmonoxide/2021-11-Florida-carbonmonoxide.txt": 75821,
	"./2021/carbonmonoxide/2021-11-Illinois-carbonmonoxide.txt": 43305,
	"./2021/carbonmonoxide/2021-11-New-York-carbonmonoxide.txt": 88921,
	"./2021/carbonmonoxide/2021-11-Texas-carbonmonoxide.txt": 88822,
	"./2021/carbonmonoxide/2021-12-California-carbonmonoxide.txt": 74209,
	"./2021/carbonmonoxide/2021-12-Florida-carbonmonoxide.txt": 41252,
	"./2021/carbonmonoxide/2021-12-Illinois-carbonmonoxide.txt": 59657,
	"./2021/carbonmonoxide/2021-12-New-York-carbonmonoxide.txt": 30811,
	"./2021/carbonmonoxide/2021-12-Texas-carbonmonoxide.txt": 15421,
	"./2021/methane/2021-01-California-methane.txt": 42845,
	"./2021/methane/2021-01-Florida-methane.txt": 88211,
	"./2021/methane/2021-01-Illinois-methane.txt": 54119,
	"./2021/methane/2021-01-New-York-methane.txt": 30146,
	"./2021/methane/2021-01-Texas-methane.txt": 7728,
	"./2021/methane/2021-02-California-methane.txt": 89212,
	"./2021/methane/2021-02-Florida-methane.txt": 65953,
	"./2021/methane/2021-02-Illinois-methane.txt": 86631,
	"./2021/methane/2021-02-New-York-methane.txt": 56946,
	"./2021/methane/2021-02-Texas-methane.txt": 573,
	"./2021/methane/2021-03-California-methane.txt": 28796,
	"./2021/methane/2021-03-Florida-methane.txt": 50469,
	"./2021/methane/2021-03-Illinois-methane.txt": 69314,
	"./2021/methane/2021-03-New-York-methane.txt": 14912,
	"./2021/methane/2021-03-Texas-methane.txt": 37386,
	"./2021/methane/2021-04-California-methane.txt": 14754,
	"./2021/methane/2021-04-Florida-methane.txt": 25157,
	"./2021/methane/2021-04-Illinois-methane.txt": 47523,
	"./2021/methane/2021-04-New-York-methane.txt": 69297,
	"./2021/methane/2021-04-Texas-methane.txt": 29645,
	"./2021/methane/2021-05-California-methane.txt": 36940,
	"./2021/methane/2021-05-Florida-methane.txt": 51570,
	"./2021/methane/2021-05-Illinois-methane.txt": 90770,
	"./2021/methane/2021-05-New-York-methane.txt": 15976,
	"./2021/methane/2021-05-Texas-methane.txt": 29017,
	"./2021/methane/2021-06-California-methane.txt": 41754,
	"./2021/methane/2021-06-Florida-methane.txt": 39553,
	"./2021/methane/2021-06-Illinois-methane.txt": 40536,
	"./2021/methane/2021-06-New-York-methane.txt": 83630,
	"./2021/methane/2021-06-Texas-methane.txt": 7161,
	"./2021/methane/2021-07-California-methane.txt": 44500,
	"./2021/methane/2021-07-Florida-methane.txt": 39636,
	"./2021/methane/2021-07-Illinois-methane.txt": 38291,
	"./2021/methane/2021-07-New-York-methane.txt": 74051,
	"./2021/methane/2021-07-Texas-methane.txt": 73398,
	"./2021/methane/2021-08-California-methane.txt": 6883,
	"./2021/methane/2021-08-Florida-methane.txt": 99672,
	"./2021/methane/2021-08-Illinois-methane.txt": 19330,
	"./2021/methane/2021-08-New-York-methane.txt": 32673,
	"./2021/methane/2021-08-Texas-methane.txt": 2612,
	"./2021/methane/2021-09-California-methane.txt": 39550,
	"./2021/methane/2021-09-Florida-methane.txt": 8263,
	"./2021/methane/2021-09-Illinois-methane.txt": 92873,
	"./2021/methane/2021-09-New-York-methane.txt": 3160,
	"./2021/methane/2021-09-Texas-methane.txt": 35943,
	"./2021/methane/2021-10-California-methane.txt": 90070,
	"./2021/methane/2021-10-Florida-methane.txt": 63889,
	"./2021/methane/2021-10-Illinois-methane.txt": 20797,
	"./2021/methane/2021-10-New-York-methane.txt": 85845,
	"./2021/methane/2021-10-Texas-methane.txt": 61466,
	"./2021/methane/2021-11-California-methane.txt": 92310,
	"./2021/methane/2021-11-Florida-methane.txt": 57784,
	"./2021/methane/2021-11-Illinois-methane.txt": 37820,
	"./2021/methane/2021-11-New-York-methane.txt": 36408,
	"./2021/methane/2021-11-Texas-methane.txt": 41370,
	"./2021/methane/2021-12-California-methane.txt": 36812,
	"./2021/methane/2021-12-Florida-methane.txt": 50464,
	"./2021/methane/2021-12-Illinois-methane.txt": 42725,
	"./2021/methane/2021-12-New-York-methane.txt": 83938,
	"./2021/methane/2021-12-Texas-methane.txt": 75552,
	"./2021/nitrogendioxide/2021-01-California-nitrogendioxide.txt": 93235,
	"./2021/nitrogendioxide/2021-01-Florida-nitrogendioxide.txt": 57103,
	"./2021/nitrogendioxide/2021-01-Illinois-nitrogendioxide.txt": 85196,
	"./2021/nitrogendioxide/2021-01-New-York-nitrogendioxide.txt": 69589,
	"./2021/nitrogendioxide/2021-01-Texas-nitrogendioxide.txt": 83088,
	"./2021/nitrogendioxide/2021-02-California-nitrogendioxide.txt": 7313,
	"./2021/nitrogendioxide/2021-02-Florida-nitrogendioxide.txt": 98537,
	"./2021/nitrogendioxide/2021-02-Illinois-nitrogendioxide.txt": 82847,
	"./2021/nitrogendioxide/2021-02-New-York-nitrogendioxide.txt": 77193,
	"./2021/nitrogendioxide/2021-02-Texas-nitrogendioxide.txt": 82583,
	"./2021/nitrogendioxide/2021-03-California-nitrogendioxide.txt": 29060,
	"./2021/nitrogendioxide/2021-03-Florida-nitrogendioxide.txt": 6789,
	"./2021/nitrogendioxide/2021-03-Illinois-nitrogendioxide.txt": 90205,
	"./2021/nitrogendioxide/2021-03-New-York-nitrogendioxide.txt": 78157,
	"./2021/nitrogendioxide/2021-03-Texas-nitrogendioxide.txt": 76094,
	"./2021/nitrogendioxide/2021-04-California-nitrogendioxide.txt": 47145,
	"./2021/nitrogendioxide/2021-04-Florida-nitrogendioxide.txt": 86221,
	"./2021/nitrogendioxide/2021-04-Illinois-nitrogendioxide.txt": 28892,
	"./2021/nitrogendioxide/2021-04-New-York-nitrogendioxide.txt": 27120,
	"./2021/nitrogendioxide/2021-04-Texas-nitrogendioxide.txt": 75466,
	"./2021/nitrogendioxide/2021-05-California-nitrogendioxide.txt": 82454,
	"./2021/nitrogendioxide/2021-05-Florida-nitrogendioxide.txt": 53942,
	"./2021/nitrogendioxide/2021-05-Illinois-nitrogendioxide.txt": 4452,
	"./2021/nitrogendioxide/2021-05-New-York-nitrogendioxide.txt": 70677,
	"./2021/nitrogendioxide/2021-05-Texas-nitrogendioxide.txt": 14948,
	"./2021/nitrogendioxide/2021-06-California-nitrogendioxide.txt": 64062,
	"./2021/nitrogendioxide/2021-06-Florida-nitrogendioxide.txt": 50506,
	"./2021/nitrogendioxide/2021-06-Illinois-nitrogendioxide.txt": 11726,
	"./2021/nitrogendioxide/2021-06-New-York-nitrogendioxide.txt": 76020,
	"./2021/nitrogendioxide/2021-06-Texas-nitrogendioxide.txt": 17051,
	"./2021/nitrogendioxide/2021-07-California-nitrogendioxide.txt": 25141,
	"./2021/nitrogendioxide/2021-07-Florida-nitrogendioxide.txt": 68714,
	"./2021/nitrogendioxide/2021-07-Illinois-nitrogendioxide.txt": 77139,
	"./2021/nitrogendioxide/2021-07-New-York-nitrogendioxide.txt": 14266,
	"./2021/nitrogendioxide/2021-07-Texas-nitrogendioxide.txt": 42790,
	"./2021/nitrogendioxide/2021-08-California-nitrogendioxide.txt": 58210,
	"./2021/nitrogendioxide/2021-08-Florida-nitrogendioxide.txt": 16415,
	"./2021/nitrogendioxide/2021-08-Illinois-nitrogendioxide.txt": 71267,
	"./2021/nitrogendioxide/2021-08-New-York-nitrogendioxide.txt": 40464,
	"./2021/nitrogendioxide/2021-08-Texas-nitrogendioxide.txt": 48030,
	"./2021/nitrogendioxide/2021-09-California-nitrogendioxide.txt": 74241,
	"./2021/nitrogendioxide/2021-09-Florida-nitrogendioxide.txt": 80724,
	"./2021/nitrogendioxide/2021-09-Illinois-nitrogendioxide.txt": 31641,
	"./2021/nitrogendioxide/2021-09-New-York-nitrogendioxide.txt": 78583,
	"./2021/nitrogendioxide/2021-09-Texas-nitrogendioxide.txt": 6851,
	"./2021/nitrogendioxide/2021-10-California-nitrogendioxide.txt": 80390,
	"./2021/nitrogendioxide/2021-10-Florida-nitrogendioxide.txt": 70048,
	"./2021/nitrogendioxide/2021-10-Illinois-nitrogendioxide.txt": 74567,
	"./2021/nitrogendioxide/2021-10-New-York-nitrogendioxide.txt": 21969,
	"./2021/nitrogendioxide/2021-10-Texas-nitrogendioxide.txt": 1837,
	"./2021/nitrogendioxide/2021-11-California-nitrogendioxide.txt": 41593,
	"./2021/nitrogendioxide/2021-11-Florida-nitrogendioxide.txt": 27678,
	"./2021/nitrogendioxide/2021-11-Illinois-nitrogendioxide.txt": 18784,
	"./2021/nitrogendioxide/2021-11-New-York-nitrogendioxide.txt": 268,
	"./2021/nitrogendioxide/2021-11-Texas-nitrogendioxide.txt": 88592,
	"./2021/nitrogendioxide/2021-12-California-nitrogendioxide.txt": 83511,
	"./2021/nitrogendioxide/2021-12-Florida-nitrogendioxide.txt": 57038,
	"./2021/nitrogendioxide/2021-12-Illinois-nitrogendioxide.txt": 37635,
	"./2021/nitrogendioxide/2021-12-New-York-nitrogendioxide.txt": 4247,
	"./2021/nitrogendioxide/2021-12-Texas-nitrogendioxide.txt": 27325,
	"./2021/ozone/2021-01-California-ozone.txt": 79997,
	"./2021/ozone/2021-01-Florida-ozone.txt": 10784,
	"./2021/ozone/2021-01-Illinois-ozone.txt": 15870,
	"./2021/ozone/2021-01-New-York-ozone.txt": 46493,
	"./2021/ozone/2021-01-Texas-ozone.txt": 88751,
	"./2021/ozone/2021-02-California-ozone.txt": 56674,
	"./2021/ozone/2021-02-Florida-ozone.txt": 75508,
	"./2021/ozone/2021-02-Illinois-ozone.txt": 9006,
	"./2021/ozone/2021-02-New-York-ozone.txt": 23632,
	"./2021/ozone/2021-02-Texas-ozone.txt": 65336,
	"./2021/ozone/2021-03-California-ozone.txt": 14308,
	"./2021/ozone/2021-03-Florida-ozone.txt": 25334,
	"./2021/ozone/2021-03-Illinois-ozone.txt": 6739,
	"./2021/ozone/2021-03-New-York-ozone.txt": 63934,
	"./2021/ozone/2021-03-Texas-ozone.txt": 64971,
	"./2021/ozone/2021-04-California-ozone.txt": 27733,
	"./2021/ozone/2021-04-Florida-ozone.txt": 75714,
	"./2021/ozone/2021-04-Illinois-ozone.txt": 56304,
	"./2021/ozone/2021-04-New-York-ozone.txt": 21987,
	"./2021/ozone/2021-04-Texas-ozone.txt": 43698,
	"./2021/ozone/2021-05-California-ozone.txt": 9612,
	"./2021/ozone/2021-05-Florida-ozone.txt": 51785,
	"./2021/ozone/2021-05-Illinois-ozone.txt": 93749,
	"./2021/ozone/2021-05-New-York-ozone.txt": 85298,
	"./2021/ozone/2021-05-Texas-ozone.txt": 35879,
	"./2021/ozone/2021-06-California-ozone.txt": 20126,
	"./2021/ozone/2021-06-Florida-ozone.txt": 19649,
	"./2021/ozone/2021-06-Illinois-ozone.txt": 9022,
	"./2021/ozone/2021-06-New-York-ozone.txt": 53880,
	"./2021/ozone/2021-06-Texas-ozone.txt": 56666,
	"./2021/ozone/2021-07-California-ozone.txt": 86351,
	"./2021/ozone/2021-07-Florida-ozone.txt": 42861,
	"./2021/ozone/2021-07-Illinois-ozone.txt": 79794,
	"./2021/ozone/2021-07-New-York-ozone.txt": 89189,
	"./2021/ozone/2021-07-Texas-ozone.txt": 32800,
	"./2021/ozone/2021-08-California-ozone.txt": 40240,
	"./2021/ozone/2021-08-Florida-ozone.txt": 49205,
	"./2021/ozone/2021-08-Illinois-ozone.txt": 54361,
	"./2021/ozone/2021-08-New-York-ozone.txt": 93939,
	"./2021/ozone/2021-08-Texas-ozone.txt": 59852,
	"./2021/ozone/2021-09-California-ozone.txt": 69797,
	"./2021/ozone/2021-09-Florida-ozone.txt": 96662,
	"./2021/ozone/2021-09-Illinois-ozone.txt": 30946,
	"./2021/ozone/2021-09-New-York-ozone.txt": 74488,
	"./2021/ozone/2021-09-Texas-ozone.txt": 63525,
	"./2021/ozone/2021-10-California-ozone.txt": 86314,
	"./2021/ozone/2021-10-Florida-ozone.txt": 40180,
	"./2021/ozone/2021-10-Illinois-ozone.txt": 63295,
	"./2021/ozone/2021-10-New-York-ozone.txt": 30447,
	"./2021/ozone/2021-10-Texas-ozone.txt": 17452,
	"./2021/ozone/2021-11-California-ozone.txt": 92187,
	"./2021/ozone/2021-11-Florida-ozone.txt": 81481,
	"./2021/ozone/2021-11-Illinois-ozone.txt": 25548,
	"./2021/ozone/2021-11-New-York-ozone.txt": 57275,
	"./2021/ozone/2021-11-Texas-ozone.txt": 43464,
	"./2021/ozone/2021-12-California-ozone.txt": 74266,
	"./2021/ozone/2021-12-Florida-ozone.txt": 70483,
	"./2021/ozone/2021-12-Illinois-ozone.txt": 4925,
	"./2021/ozone/2021-12-New-York-ozone.txt": 65947,
	"./2021/ozone/2021-12-Texas-ozone.txt": 82730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98129;